﻿import React from 'react';
import ReactModal from 'react-modal';
import { connect } from 'react-redux';
import { ThunkDispatch } from 'redux-thunk';
import { AnyAction } from 'redux';

import { EpiContext } from '../Shared/Scripts/Store/EpiContext/Types';
import { FeilmeldingComponent } from '../Shared/Scripts/Components/FeilmeldingComponent';
import contentResolver from '../Shared/Scripts/Utilities/EpiContentResolver';
import RadioButtonsStegContainer from '../Shared/Scripts/Components/RadioButtonsStegComponent';
import Valg from '../Shared/Scripts/Models/Valg';

import AUtdanningValg from './Utilities/A-UtdanningsValg';
import VeilederOblDto from './Models/VeilederOblDto';
import { VeilederOblAppState } from './Store';
import * as Ids from './Ids';
import * as ValgTypes from './Store/Valg/Types';
import { updateValg, updateVisning } from './Store/Valg/Actions';
import ResultatContainer from './Components/ResultatComponent';
import { ResultatValg } from './Store/Resultat/Types';
import BGradValg from './Utilities/B-GradsValg';
import { registerAnalyticsEvent } from '../Shared/Scripts/Utilities/Analytics';
import * as VisningsLogikk from './ResultatVisning';

interface AppOwnProps {}

type AppProps = AppOwnProps & MapStateToProps & MapDispatchToProps;

const RadioButtonsStegComponent = RadioButtonsStegContainer<VeilederOblDto>();

const container = document.getElementById(Ids.AppContainerId)!;
ReactModal.setAppElement(container);

const analyticsState = { startet: false, fullfort: false };
const eventId = container.parentElement!.getAttribute('data-eventid');

export class App extends React.Component<AppProps> {
    constructor(props: AppProps) {
        super(props);
    }

    render(): JSX.Element {
        const { valg, resultat, dispatchUpdateValg, epiContext } = this.props;
        const { epiModel } = this.props.epiContext;

        function registerEvents(): void {
            if (!analyticsState.startet) {
                if (valg.aUtdanning != undefined) {
                    analyticsState.startet = true;
                    registerAnalyticsEvent({ action: 'VeilederStart', eventId });
                }
            }

            if (!analyticsState.fullfort) {
                if (resultat.visResultat) {
                    analyticsState.fullfort = true;
                    registerAnalyticsEvent({ action: 'VeilederFerdig', eventId });
                }
            }
        }

        if (epiContext.epiModelFeilet) {
            return <FeilmeldingComponent />;
        }

        if (epiModel != null) {
            return (
                <div className="c-veileder">
                    {registerEvents()}
                    <RadioButtonsStegComponent
                        sporsmalId={Ids.BoksA}
                        tittel={contentResolver(epiContext, 'tittelUtdanning')}
                        forklaring={contentResolver(epiContext, 'infoUtdanning')}
                        sporsmal="ledetekstUtdanning"
                        valg={AUtdanningValg.aValg}
                        onInputChange={(nyttValg: Valg<string>): void => {
                            dispatchUpdateValg({ aUtdanning: nyttValg });
                        }}
                        neverCollapse={true}
                        classModifier="c-veileder__panel--input-white"
                        value={valg.aUtdanning}
                    />
                    {resultat.visBoksB && (
                        <RadioButtonsStegComponent
                            sporsmalId={Ids.BoksB}
                            tittel={contentResolver(epiContext, 'tittelGrad')}
                            forklaring={
                                <div>
                                    <p>{contentResolver(epiContext, 'ledetekstGrad')}</p>
                                </div>
                            }
                            sporsmal="ledetekstGrad"
                            valg={BGradValg.bValg}
                            onInputChange={(nyttValg: Valg<string>): void => {
                                dispatchUpdateValg({ bGrad: nyttValg });
                            }}
                            value={valg.bGrad}
                        />
                    )}
                    {resultat.visBoksBx && (
                        <RadioButtonsStegComponent
                            sporsmalId={Ids.BoksBx}
                            tittel={contentResolver(epiContext, 'tittelGrad')}
                            forklaring={
                                <div>
                                    <p>{contentResolver(epiContext, 'ledetekstGrad')}</p>
                                </div>
                            }
                            sporsmal="ledetekstGrad"
                            valg={BGradValg.bxValg}
                            onInputChange={(nyttValg: Valg<string>): void => {
                                dispatchUpdateValg({ bxGrad: nyttValg });
                            }}
                            value={valg.bxGrad}
                        />
                    )}
                    {resultat.visResultat && <ResultatContainer resultat={VisningsLogikk.getResultat(valg)} eventId={eventId} />}
                </div>
            );
        } else {
            return <div>Laster...</div>;
        }
    }
}

interface MapStateToProps {
    valg: ValgTypes.ValgState;
    epiContext: EpiContext<VeilederOblDto>;
    resultat: ResultatValg;
}

interface MapDispatchToProps {
    dispatchUpdateValg: (newValg: Partial<ValgTypes.ValgState>) => void;
}

const mapDispatchToProps = (dispatch: ThunkDispatch<VeilederOblAppState, {}, AnyAction>): MapDispatchToProps => ({
    dispatchUpdateValg: (newValg: Partial<ValgTypes.ValgState>): void => {
        dispatch(updateValg(newValg));
        dispatch(updateVisning());
    },
});

const mapStateToProps = (state: VeilederOblAppState): MapStateToProps => ({
    valg: state.valg,
    epiContext: state.epiContext,
    resultat: state.resultat,
});

export default connect(mapStateToProps, mapDispatchToProps)(App);
